import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-chart-bar",
  templateUrl: "./med-icon-chart-bar.component.html",
})
export class MedIconChartBarComponent extends SvgMixinComponent {}
